/**
 * Creates a context for custom layout configurations.
 *
 * This context is used to provide custom layout settings throughout the component tree.
 *
 * @typedef {Object} CustomLayoutConfig
 * @property {boolean} [isUseHyperlinkStyle] - Indicates whether the hyperlink style is applied.
 * @property {boolean} [isUseBreadcrumbStyle] - Indicates whether the breadcrumb style is applied.
 * @property {boolean} [isUseCustomTheme] - Indicates whether the custom theme is applied.
 */

import { createContext } from "react";

export type CustomLayoutConfig = {
  isUseHyperlinkStyle?: boolean;
  isUseBreadcrumbStyle?: boolean;
  isUseCustomTheme?: boolean;
};

export const CustomLayoutContext =
  createContext<CustomLayoutConfig | undefined>(undefined);